import React, { useEffect, useRef, useState } from "react";
// import { FooterComponents } from "../../components/FooterComponents/FooterComponents";
//import './HomePageScreen.css';
// import 'primeflex/primeflex.css';
// import { Card } from 'primereact/card';
// import { Carousel } from 'primereact/carousel'
import { useParams, useLocation, useHistory } from "react-router-dom";
import { Breadcrumb, Layout, Menu, Button, PageHeader, Row, Col, Form, Input, Select, Skeleton, notification, Card, Space, Empty, Spin  } from 'antd';

import { ECatalogNavigation } from "../../components/ECatalogComponents/ECatalogNavigation";
import "./ProductDetailScreen.css";
import { BsCartPlus } from "react-icons/bs";
import { useCart } from "react-use-cart";
import { SearchCatalogItem, GetWolfTemplate } from "../../Services/EcatalogService";
import { IProductItem } from "../../IRequestModel/ECatalog/IProductItemModel";
import { MapsDataToProductObject, SetViewItemToLocalStorage } from "../../Helper/ECatalogHelper";
import LatestViewProduct from "../../components/ECatalogComponents/LatestViewProduct";
import { MdDoNotDisturbAlt, MdCheckCircle } from "react-icons/md";
import { PlusCircleOutlined, FilterOutlined } from '@ant-design/icons';
import ProductItem from "../../components/ECatalogComponents/ProductItem";
import { GetAllMasterCategotryGroup } from "../../Services/EcatalogService";
import $ from 'jquery';
import { useECatalogContext } from "../../Context/ECatalogContext";
import UnAurthorization from "../UnAuthorizePage/UnAurthorization";
import { useUserContext } from "../../Context/UserContext";
interface Props { responeConfig?: { pathLoading?: string } }
const { Header, Content, Footer, Sider } = Layout;

export function useEffectAsync(effect:any, inputs:any) {
    useEffect(() => {
      return effect();
    }, [effect]);
  } 
export const SearchProductScreen = (props: Props) => {
    const query = new URLSearchParams(useLocation().search);
    const history = useHistory();
    let queryText = query.get("query");
    let categoryId = query.get("catid");
    let categoryText = query.get("cattxt");
    const [products, setProducts] = useState<IProductItem[]>([]);
    const [loading, setLoading] = useState(false);
    const [categoryItem, setCategoryItem] = useState<MenuItem[]>([]);
    const [productCategory, setProductCategory] = useState<any[]>([]);
    const [menuCategoryOpen, setMenuCategoryOpen] = useState(false);
    
    const checkEcatalog = useECatalogContext();
    const [isAuthorize, setIsAuthorizeo] = useState(true);
    const [isEditECatalog, setIsEditECatalog] = useState(true);
    const [userData, setUserData] = useUserContext();
    const [categorySearchText, setCategorySearchText] = useState(null);
    const [searchInputValue, setSearchInputValue] = useState("");
    const {
        isEmpty,
        totalUniqueItems,
        items,
        updateItemQuantity,
        removeItem,
        totalItems,
        addItem
    } = useCart();
    const [form] = Form.useForm();
    const categoryRef = useRef(null);

    const handleClickOutside = (event) => {
        if (categoryRef.current && !categoryRef.current.contains(event.target)) {
          setMenuCategoryOpen(false);
        }
        
      };

    useEffect(() => {
        setLoading(true);
        //$("#root > .navbar-container").hide();
        getProducts();
        getProductCategory();
        document.addEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        setLoading(true);
        getProducts();
        setSearchInputValue(queryText);
        setCategorySearchText(categoryText);
    }, [queryText, categoryId,  categoryText]);

    useEffect(() => {
        if (checkEcatalog.roleData  != null)
        {
            setIsAuthorizeo(checkEcatalog.canAccess);
            setIsEditECatalog(checkEcatalog.canEdit);
            
        }
        console.log(checkEcatalog);
    }, [checkEcatalog]);


    async function getProducts() {
        // const response = await fetch('https://dummyjson.com/products/' + productId)  // fetch the products
        // const data = await response.json() // convert the response to json
        // setProductDetail(data) // set the products in the state to the products we fetched
        // console.log(data);
        setLoading(true);
        const dataJson = {
            SearchItem : queryText != null ? queryText : "",
            CategoryCode : categoryId != null ? categoryId : 0,
            EmployeeId: userData.EmployeeId
          };
        let response = await SearchCatalogItem(dataJson);
        const data = response.data;
        

        if (data === null){ setLoading(false); setProducts([]); return; } 
        let productItem: IProductItem[] = MapsDataToProductObject(data);
        setProducts(productItem);
        setLoading(false);
        return productItem;
    }
    async function getProductCategory() {
        const response = await GetAllMasterCategotryGroup({CategoryGroupID: null});
        const data = response.data;
        setProductCategory(data);
        //console.log(data); 
        processMenuItem(data);
      }

    const processMenuItem = (source:any) => {
        const items: MenuItem[] = processSubMenuItem(source);
        setCategoryItem(items);
        //console.log(items);
       
    }
    const processSubMenuItem = (source:any) => {
        const items: MenuItem[] = []
        source.map((item:any) => {
            let menu: MenuItem = {
                key: item.CategoryGroupCode,
                label: item.CategoryGroupName
            }
            items.push(menu);
        })

        return items;
    }
    const handleSearchProduct = (event) => {
        if (event.keyCode === 13) {
            

            //alert('Enter key was pressed' + event.target.value);
            
            history.push(`/searchproduct?query=` + event.target.value);
        }
    }
    const onCategoryClick: MenuProps['onClick'] = e => {
        //console.log(e);
        // Array.from(document.querySelectorAll("input")).forEach(
        //     input => (input.value = "")
        //   );
        // let inputCtrl = document.getElementsByClassName("ecat-search-input");
        // console.log(inputCtrl);
        // inputCtrl[0].value = "";
        setSearchInputValue("");
        let label = e.item.props.elementRef.current.innerText;
        history.push(`/searchproduct?catid=` + e.key + "&cattxt=" + label);
      };

    return  isAuthorize ?   (
 
        <Layout className="layout">
            <ECatalogNavigation />
            <Content style={{ padding: "0 10px" }}>
                <Layout>
                    <Sider className="ecatalog-sider" style={{ background: "transparent", /*padding: "0px 10px"*/ fontSize: "20px"}} width={300}
                    breakpoint="lg" collapsedWidth="0" >
                        <Space direction="vertical" size="middle" style={{ display: 'flex', marginTop: "20px" }}>
                            <Form
                                form={form}
                                layout="vertical"
                                className="ecatalog-filter-form"
                            >
                                <Form.Item >
                                    {/* <Button type="primary" className="btnEcatalogPrimary" shape="round" icon={<PlusCircleOutlined />} style={{ fontSize: "16px" }}>คำร้องขอเพิ่มสินค้า</Button> */}
                                    <div style={{fontSize: "20px", fontWeight: 600}}>
                                        <FilterOutlined style={{fontSize: "14px", fontWeight: 600, position: "relative", top: "-3px"}} /> ตัวกรองข้อมูล
                                        </div>
                                </Form.Item>
                                <Form.Item>
                                    <Input className="ecat-search-input"
                                        // options={options}
                                        style={{ width: "100%", fontSize: "18px", height: "30px" }}
                                        // onSelect={onSelect}
                                        // onSearch={onSearch}
                                        onKeyDown={(e) => handleSearchProduct(e)}
                                        onFocus={(e) => { setCategorySearchText(null)}}
                                        placeholder="ชื่อสินค้า / ชื่อบริษัท"
                                        value={searchInputValue}
                                        onChange={(e) => setSearchInputValue(e.target.value)}
                                    />
                                </Form.Item>
                            </Form>
                            <nav className="navbar navbar-second navbar-light navbar-expand category-navbar" ref={categoryRef}>
                                <ul className="navbar-nav mr-auto navbar-left">
                                    <li className="nav-item navbar-menu" style={{width: "100%"}} onClick={() => setMenuCategoryOpen(!menuCategoryOpen) }>
                                        <div className= { menuCategoryOpen ? "navbar-menu-list active" : "navbar-menu-list" }  >
                                            {/* <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="list" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-list b-icon bi">
                                            <g><path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"></path></g>
                                            </svg> */}
                                              {
                                                (categorySearchText != null && categorySearchText !== "" ? categorySearchText : "เลือกหมวดหมู่สินค้า")
                                            }
                                            <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="chevron down" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-chevron-down rotate b-icon bi">
                                            <g><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></g>
                                            </svg>
                                        </div>
                                    </li>
                                </ul>
                                <div className={ menuCategoryOpen ? "category-wrapper active" : "category-wrapper" } >
                                        <Menu className="category-menu"
                                        onClick={onCategoryClick}
                                        style={{ width: "100%" }}
                                        //openKeys={['11', '15']}
                                        // selectedKeys={[current]}
                                        mode="vertical"
                                        items={categoryItem}
                                        getPopupContainer={(node) => node.parentNode as HTMLElement}
                                        defaultSelectedKeys={[categoryId]}
                                    />
                                </div>
                            
                            </nav>
                            


                        </Space>
                        
                    </Sider>
                    <Content style={{ padding: "15px 10px 0", minHeight: "400px" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                            
                                <Card className="ecatalog-form-search-card" bordered={false} 
                                extra={<a href="/Ecatalog" className="btn">กลับ</a>}
                                title={
                                    queryText != null ? ( "ผลการค้นหาสำหรับ ''" + queryText + "''") :
                                    (
                                        "หมวดหมู่สินค้า ''" + categoryText + "''"
                                    )
                                

                                } size={"small"}>
                                    <Spin spinning={loading}>
                                    {
                                        
                                        products != null && products.length > 0 ? (
                                            <Space style={{ display: "flex" }} wrap>
                                            {
                                                products.map(product => (
                                                        <>
                                                            <ProductItem product={product} ShowQuantity={isEditECatalog} ></ProductItem>
                                                        </>
                                                ))
                                            }
                                            </Space>
                                        ) : (
                                            <Empty />
                                        )
                                    }
                                    </Spin>
                                
                                </Card>
                          
                            
                            </div>
                        </div>
                    </div>
                    



                    </Content>
                </Layout>
            </Content>

            
        </Layout>
    ) : ( <UnAurthorization />);
};